import { render, staticRenderFns } from "./TableRowNetRevPerPhysician.vue?vue&type=template&id=47f40c6c&lang=pug&"
import script from "./TableRowNetRevPerPhysician.vue?vue&type=script&lang=js&"
export * from "./TableRowNetRevPerPhysician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f40c6c')) {
      api.createRecord('47f40c6c', component.options)
    } else {
      api.reload('47f40c6c', component.options)
    }
    module.hot.accept("./TableRowNetRevPerPhysician.vue?vue&type=template&id=47f40c6c&lang=pug&", function () {
      api.rerender('47f40c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/performance-evaluation/table-rows/TableRowNetRevPerPhysician.vue"
export default component.exports